import { render } from "./ServTeamOp.vue?vue&type=template&id=ffdbe432"
import script from "./ServTeamOp.vue?vue&type=script&lang=js"
export * from "./ServTeamOp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__